/** Elimina un nodo del DOM sin lanzar si ya fue desmontado (extensiones, Strict Mode). */
export function safeRemoveNode(node) {
  if (!node?.parentNode) return;
  try {
    node.parentNode.removeChild(node);
  } catch {
    /* ignore */
  }
}

/** Copia texto al portapapeles con fallback seguro. */
export async function copyTextToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  ta.style.top = '0';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } finally {
    safeRemoveNode(ta);
  }
}
